import cx from 'classnames'
import { useState } from 'react'

import { openRequestOverlay } from '@js/common/request-flow-triggers-HDP'
import { UA } from '@js/common/UA'

import Icon from '@f/elements/Icon'

import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { useUserDetails } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useUserDetails'

interface FavoriteButtonProps {
  itemNid: string | number
  vendorNid: string
  exteriorImages?: Record<string, string>[]
}

export const FavoriteButton = ({
  itemNid,
  vendorNid,
  exteriorImages
}: FavoriteButtonProps) => {
  const userDetails = useUserDetails({})

  const [isFavourite, setIsFavourite] = useState(() => {
    return userDetails?.ua_favourites?.map(e => e.nid).includes(itemNid)
  })

  const {
    onAddToFavouriteClick,
    className: addToFavouriteClassname = '',
    ...restAddFavouriteConfig
  } = userDetails?.ua_user_state
    ? {
        'data-isfavorite': isFavourite,
        className: '',
        onAddToFavouriteClick: e => {
          e.stopPropagation()
          webtrack({
            category: 'CTA-button',
            action: 'click',
            label: 'favourite-house',
            location: 'image-gallery',
            values: [{ type: 'text', value: '(ICON)' }]
          })
          if (isFavourite) {
            UA.removeFavourite(itemNid.toString())
            setIsFavourite(false)
          } else {
            UA.addFavourite(itemNid.toString())
            setIsFavourite(true)
          }
        }
      }
    : {
        'data-request-type': 'house-wizard-item-favourite',
        'data-funnel-variant': 'house-wizard-item-favourite',
        'aria-label': 'Speichern',
        'data-sel': 'btn-fav',
        'data-house-nid': itemNid,
        className: 'js-request-button',
        ...(vendorNid && {
          'data-vendor-nid': vendorNid
        }),
        onAddToFavouriteClick: e => {
          e.stopPropagation()
          webtrack({
            category: 'CTA-button',
            action: 'click',
            label: 'favourite-house',
            location: 'image-tiles',
            indicates: ['funnel-entry'],
            values: [{ type: 'text', value: '(ICON)' }]
          })

          openRequestOverlay(e)
        }
      }

  return (
    <div
      {...restAddFavouriteConfig}
      data-sel='btn-fav-text'
      {...(vendorNid && {
        'data-vendor-nid': vendorNid
      })}
      onMouseEnter={() => {
        window.hdpPageProps = {
          houseData: {
            exterior_images: [
              {
                'max-1600x1200.watermarked':
                  exteriorImages[0]['max-1600x1200.watermarked'],
                alt_text: exteriorImages[0]['alt_text']
              }
            ]
          }
        }
      }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        onAddToFavouriteClick(e)
      }}
      className={cx('HouseCard_add-to-favourite-cta', addToFavouriteClassname)}>
      <Icon
        icon='heart-16px'
        className={cx(
          'f-icon-030 f-c-st-whi f-icon-t-mini',
          isFavourite ? 'f-c-fi-err' : 'f-c-fi-pri-050'
        )}
      />
    </div>
  )
}
